import { gql } from '@apollo/client';
import { FRAGMENTS } from '../../_fragments';

export const POSITION_PRICE_OBJECT = gql`
    query PositionPriceObject(
        $productId: String!
        $quantity: Int!
        $hidePrice: Boolean
        $projectId: Int
        $chargeNr: Int
        $pvggType: String
        $postalCode: String
    ) {
        positionPriceObject(
            productId: $productId
            quantity: $quantity
            hidePrice: $hidePrice
            projectId: $projectId
            chargeNr: $chargeNr
            pvggType: $pvggType
            postalCode: $postalCode
        ) {
            ...PositionPriceObjectFields
        }
    }
    ${FRAGMENTS.POSITION_PRICE_OBJECT}
`;
